import { render, staticRenderFns } from "./outgoods.vue?vue&type=template&id=5e4a26e8&scoped=true"
import script from "./outgoods.vue?vue&type=script&lang=js"
export * from "./outgoods.vue?vue&type=script&lang=js"
import style0 from "./outgoods.vue?vue&type=style&index=0&id=5e4a26e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a26e8",
  null
  
)

export default component.exports